import { useEffect } from "react";
import { coursesController, coursesStore } from "@/entities";
import { usePagination } from "@/shared/hooks/usePagination";
import { ModalTableList } from "@/widgets/modal/modal-table-list/ModalTableList";
import { CONFIG_APP } from "@/shared/config";
import { FilterOption } from "@/widgets/filter/filter-table/FilterTable";
import { useFilterTable } from "@/shared/hooks/useFilterTable";

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  disabledIds?: number[];
  clickModalItem: (value: { id: number; title: string; description: string; img: string }) => void;
};

const CoursesModalList = ({ clickModalItem, closeModal, isOpen, disabledIds }: Props) => {
  const { changePage, page } = usePagination();
  const { onCancelSearch, onSubminSearch, search } = useFilterTable({
    changePage,
  });
  const coursesList = coursesStore((state) => state.coursesList);
  const coursesTotalCount = coursesStore((state) => state.currentCount);

  useEffect(() => {
    const payload: Record<string, string> = {
      limit: String(7),
      page: String(page),
    };

    if (search) {
      for (let field in search) {
        payload[field] = search[field];
      }
    }

    coursesController.getAllCourses(payload);
  }, [page, search]);

  const getModalList = () => {
    return coursesList.map((item) => ({
      id: item.id,
      title: item.name,
      description: item.description,
      img: item.image ? `${CONFIG_APP.PATH_UPLOADS_PHOTO}${item.image}` : "",
    }));
  };

  const filterOptions: FilterOption[] = [
    { label: "Идентификатор", field: "id", type: "text" },
    { label: "Название", field: "name", type: "text" },
  ];

  return (
    <>
      <ModalTableList
        emptySearch={search !== null && getModalList().length === 0}
        disabledIds={disabledIds}
        onCancelSearch={onCancelSearch}
        onSubminSearch={onSubminSearch}
        filterOptions={filterOptions}
        itemList={getModalList()}
        page={page}
        changePage={changePage}
        isOpen={isOpen}
        limit={7}
        onClick={clickModalItem}
        onClose={closeModal}
        title="Выберите курс"
        totalCount={coursesTotalCount}
      />
    </>
  );
};

export { CoursesModalList };
